(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/animations/composers/keep-composer.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/animations/composers/keep-composer.js');
"use strict";


const keepComposerAsync = (slidesList, slideInTween, slideOutTween, resetTween) => new Promise(resolve => {
  if (!slidesList || slidesList.length < 2) {
    throw new Error('slideList must contain atleast 2 elements');
  }
  const duration = 0.75; 
  const tl = gsap.timeline();
  const [outEl, inEl] = slidesList;
  const inDuration = duration / inEl.length;
  const outDuration = duration / outEl.length;
  outEl.forEach((el, i) => {
    const slotTime = outDuration * i;
    tl.add(slideOutTween(el, outDuration), slotTime);
  });
  inEl.forEach((el, i) => {
    const slotTime = inDuration * i;
    tl.add(resetTween(el, 0));
    tl.add(slideInTween(el, inDuration), slotTime);
  });
  tl.eventCallback('onComplete', () => {
    resolve();
  }).play();
});
setGlobal('svs.components.onboarding.slides.animations.composers.keepComposerAsync', keepComposerAsync);

 })(window);